import { css } from 'styled-components';
import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { Text } from '@lmn/design-system';

type PaymentTypeProps = {
  paymentType: PaymentTypeType;
};

export const PaymentType = (props: PaymentTypeProps) => {
  const { t } = useTranslation();

  const textMap: { [key: string]: string } = {
    PARTIAL_PAYMENT: t('vacation.select.details.partialpayment'),
    PAY_AT_HOTEL: t('vacation.select.details.payathotel'),
  };

  return (
    <Text
      variant="BodySmall"
      css={css`
        @media ${customCss.breakpoints.sm} {
          padding-top: 0;
        }
      `}
    >
      {textMap[props.paymentType]}
    </Text>
  );
};
